module.exports = __webpack_public_path__ + "static/media/parking.01591a6d.md";